import {createFileRoute, Navigate} from "@tanstack/react-router"
import { Wallet } from '@/components/walletNew/Wallet'

export const Route = createFileRoute("/_mainLayout/wallet-old/")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <Navigate to={'/wallet'} />
  );
}
